// extracted by mini-css-extract-plugin
export var fullWidthButton = "_p9-0";